import { filtersHelper } from '@/utils';
import { candidateModel } from '@/models/api/candidate.model';
import { candidateStatusModel } from '@/models/api/candidateStatus.model';

export const candidateStatusLogModel = (data) => ({
    uuid: data.uuid,
    emailSubject: data.email_subject,
    emailTo: data.email_to,
    emailCc: data.email_cc,
    emailContent: data.email_content,
    remark: data.remark,
    isActive: data.is_active,
    createdAt: filtersHelper.getDateTimeFormat(data.created_at),
    createdBy: data.created_by,
    updatedAt: filtersHelper.getDateFormat(data.updated_at),
    updatedBy: data.updated_by,
    deletedAt: filtersHelper.getDateFormat(data.deleted_at),
    deletedBy: data.deleted_by,
    candidate: data.candidate ? candidateModel(data.candidate) : null,
    candidateStatus: data.candidate_status ? candidateStatusModel(data.candidate_status) : null,
});